var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-chip',_vm._g({staticClass:"gl-chip",class:_vm.classes,attrs:{"md-deletable":_vm.deletable}},_vm.listerners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }